<form [formGroup]="form">

  <div class="form-row">
    <label for="txtTitle">Título</label>
    <input type="text" id="txtTitle" class="w-full" pInputText formControlName="title" maxlength="255" />
  </div>

</form>

<div class="p-dialog-footer">
  <p-button label="Guardar cambios" (click)="saveChanges()" [loading]="saving"></p-button>
</div>